module.exports = __webpack_public_path__ + "img/anquanzhongxin1.2a31fe22.png";